import { memo, useRef, useState } from "react";
import {
    TransformWrapper,
    TransformComponent,
    useControls,
} from "react-zoom-pan-pinch";
import { Modal } from 'react-bootstrap';
import fullScreenimg from '../../assets/images/full-screen.png'

const CustomPhoto = ({
    rotation,
    setRotation,
    setLoading,
    imgsrc,
    isimgrotation = true,
    showLoader,
    hideLoader
}) => {
    const imageRef = useRef(null);
    const { innerWidth: width, innerHeight: height } = window;

    const [isZommImage, setisZommImage] = useState(false);

    // Function to handle rotation with blur effect
    const handleRotate = (degrees) => {
       showLoader();
        const finalRotation = (rotation + degrees) % 360;
        setTimeout(() => {
            setRotation(finalRotation);
            hideLoader();
        }, 100);
    };

    const Controls = () => {
        const { zoomIn, zoomOut, resetTransform } = useControls();

        return (
            <div class="text-center p-3 zoomimg-container" >
                <span className="me-4" style={{ color: 'white' }} onClick={() => zoomIn()}>  <i className='fa-solid fa-magnifying-glass-plus p-1' alt="Zoom In"></i> Zoom In</span>
                <span className="me-4" style={{ color: 'white' }} onClick={() => zoomOut()}> <i className='fa-solid fa-magnifying-glass-minus p-1' alt="Zoom Out"></i> Zoom Out</span>
                <span className="me-4" style={{ color: 'white' }} onClick={() => { resetTransform(); setRotation(0) }}> <i className='fa-solid fa-arrows-rotate p-1' alt="Reset"></i> Reset</span>

                <span className="me-4" style={{ color: 'white' }} onClick={() => handleRotate(90)}> <i className='fa-solid fa-rotate-right' alt="Rotate 90 Degree"></i></span>

                <span className="me-4" style={{ color: 'white' }} onClick={() => handleRotate(180)}>  <i className="fa-solid fa-repeat" alt="Rotate 180 Degree"></i></span>

                <span className="me-4" style={{ color: 'white' }} onClick={() => handleRotate(-90)}>   <i className='fa-solid fa-rotate-left' alt="Rotate 270 Degree"></i></span>

                <span className="me-4" style={{ color: 'white' }} onClick={() => {setisZommImage(false); setRotation(0)} }>   <i className='fa-solid fa-xmark p-1' alt="Close"></i> Close</span>

            </div>
        );
    };

    const ZoomImageComponent = () => {
        return (
            <TransformWrapper >
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                        <Controls />
                        <TransformComponent>
                            <div
                                className="Zoomimage-container"
                            >
                                <img
                                    onClick={() => { setisZommImage(true) }}
                                    ref={imageRef}
                                    src={imgsrc}
                                    alt="Base64"
                                    className="responsive-image"
                                    style={{ transform: `rotate(${rotation}deg)` }}
                                    // style={{
                                    //     transform: `rotate(${rotation}deg)`,
                                    //     height: '100%',
                                    //     objectFit: 'contain', 
                                    //     marginTop: '0', 
                                    //     maxHeight: '80vh',
                                    //     minHeight: '80vh',
                                    //     minWidth: '80vh', maxWidth: '80vh'
                                        
                                    // }}
                                />
                            </div>
                        </TransformComponent>
                    </>
                )}
            </TransformWrapper>
        );
    };

    return (
        <div >

            {!isZommImage ?
                <div className="image-rotator">
                    <div className= {!isimgrotation ? "ecard-wrapper":"image-wrapper"}>
                        {isimgrotation && <div className="rotation-buttons">
                            {/* Rotate 90 Degree */}
                            <button
                                onClick={() => handleRotate(90)}
                                title="Rotate 90 Degree"
                                className="btn btn-danger mrl-10 fs-14 me-2"
                            >
                                <i className='fa-solid fa-rotate-right' alt="Rotate 90 Degree"></i>
                            </button>
                            <button
                                onClick={() => handleRotate(180)}
                                title="Rotate 180 Degree"
                                className="btn btn-danger mrl-10 fs-14 me-2"
                            >
                                <i className="fa-solid fa-repeat" alt="Rotate 180 Degree"></i>
                            </button>
                            <button
                                onClick={() => handleRotate(-90)}
                                title="Rotate 270 Degree"
                                className="btn btn-danger mrl-10 fs-14 me-2"
                            >
                                <i className='fa-solid fa-rotate-left' alt="Rotate 270 Degree"></i>
                            </button>
                        </div>}
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                                width: window.innerWidth <= 850 ? '250px' : height - 400,
                                height: window.innerWidth <= 850 ? '250px' : height - 400,
                                overflow: 'hidden',
                                position: 'relative',
                                marginTop: '30px'
                            }}
                        >
                            <img
                                onClick={() => { setisZommImage(true) }}
                                ref={imageRef}
                                src={imgsrc}
                                alt="Base64"
                                style={{
                                    transform: `rotate(${rotation}deg)`,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain', // Ensures the full image is displayed
                                    marginTop: '0', // Adjust margin if needed
                                }}
                            />
                        </div>

                    </div>
                </div> :
                <Modal show={isZommImage} size='xl' onHide={() => setisZommImage(false)} centered>
                    <Modal.Body style={{
                        position: 'fixed', top: 0, left: 0,
                        width: '100%', backgroundColor: 'rgb(0 1 14 / 50%)', height: '100%',
                    }}>
                        <ZoomImageComponent />
                    </Modal.Body>
                </Modal>
            }
        </div>
    );
};

export default memo(CustomPhoto);
